import type i18nType from '@dms/i18n';

import {getSafely} from 'shared/web';

const PREFERRED_LANGUAGE_CODES = {
  ENGLISH: 'en-GB',
  FRENCH: 'fr-FR',
  DUTCH: 'nl-NL',
  GERMAN: 'de-DE',
} as const;

const PREFERRED_LANGUAGE_LABELS: Record<string, string> = {
  'en-GB': 'general.labels.languages.english',
  'fr-FR': 'general.labels.languages.french',
  'nl-NL': 'general.labels.languages.dutch',
  'de-DE': 'general.labels.languages.german',
} as const;

export const getPreferredLanguageOptions = (i18n: typeof i18nType) =>
  Object.values(PREFERRED_LANGUAGE_CODES).map((value) => ({
    label: i18n.t(getSafely(PREFERRED_LANGUAGE_LABELS, value) ?? value),
    value,
  }));

export const getPreferredLanguageName = (
  i18n: typeof i18nType,
  code: string | null | undefined
) => {
  if (!code) {
    return null;
  }
  const labelKey = getSafely(PREFERRED_LANGUAGE_LABELS, code);
  return labelKey ? i18n.t(labelKey) : code;
};
